/**
 * Generated by orval 🍺
 * Do not edit manually.
 * standard public schema
 * OpenAPI spec version: 16.1
 */
import type {
  DeleteNotificationRecipientsParams,
  GetNotificationRecipientsParams,
  NotificationRecipients,
  NotificationRecipientsInsertPayload,
  NotificationRecipientsUpdate,
  PatchNotificationRecipientsParams,
  PostNotificationRecipientsParams,
  PostgrestError
} from '../../models';

import {
  backendBaseUrl
} from '@/api/vtnz-backend/baseUrl';


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export type getNotificationRecipientsResponse200 = {
  data: NotificationRecipients[]
  status: 200
}

export type getNotificationRecipientsResponse206 = {
  data: NotificationRecipients[]
  status: 206
}

export type getNotificationRecipientsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200 | 206>
}

export type getNotificationRecipientsResponseSuccess = (getNotificationRecipientsResponse200 | getNotificationRecipientsResponse206) & {
  headers: Headers;
};
export type getNotificationRecipientsResponseError = (getNotificationRecipientsResponseDefault) & {
  headers: Headers;
};

export type getNotificationRecipientsResponse = (getNotificationRecipientsResponseSuccess | getNotificationRecipientsResponseError)

export const getGetNotificationRecipientsUrl = (params?: GetNotificationRecipientsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/notification_recipients?${stringifiedParams}` : `${backendBaseUrl}/notification_recipients`
}

/**
 * @summary Read rows from `notification_recipients`.
 */
export const getNotificationRecipients = async (params?: GetNotificationRecipientsParams, options?: RequestInit): Promise<getNotificationRecipientsResponse> => {

  const res = await fetch(getGetNotificationRecipientsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getNotificationRecipientsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getNotificationRecipientsResponse
}


export type postNotificationRecipientsResponse201 = {
  data: NotificationRecipients[]
  status: 201
}

export type postNotificationRecipientsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 201>
}

export type postNotificationRecipientsResponseSuccess = (postNotificationRecipientsResponse201) & {
  headers: Headers;
};
export type postNotificationRecipientsResponseError = (postNotificationRecipientsResponseDefault) & {
  headers: Headers;
};

export type postNotificationRecipientsResponse = (postNotificationRecipientsResponseSuccess | postNotificationRecipientsResponseError)

export const getPostNotificationRecipientsUrl = (params?: PostNotificationRecipientsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/notification_recipients?${stringifiedParams}` : `${backendBaseUrl}/notification_recipients`
}

/**
 * @summary Insert one or more rows into `notification_recipients`.
 */
export const postNotificationRecipients = async (notificationRecipientsInsertPayload: NotificationRecipientsInsertPayload,
    params?: PostNotificationRecipientsParams, options?: RequestInit): Promise<postNotificationRecipientsResponse> => {

  const res = await fetch(getPostNotificationRecipientsUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notificationRecipientsInsertPayload)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postNotificationRecipientsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postNotificationRecipientsResponse
}


export type patchNotificationRecipientsResponse200 = {
  data: NotificationRecipients[]
  status: 200
}

export type patchNotificationRecipientsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchNotificationRecipientsResponseSuccess = (patchNotificationRecipientsResponse200) & {
  headers: Headers;
};
export type patchNotificationRecipientsResponseError = (patchNotificationRecipientsResponseDefault) & {
  headers: Headers;
};

export type patchNotificationRecipientsResponse = (patchNotificationRecipientsResponseSuccess | patchNotificationRecipientsResponseError)

export const getPatchNotificationRecipientsUrl = (params?: PatchNotificationRecipientsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/notification_recipients?${stringifiedParams}` : `${backendBaseUrl}/notification_recipients`
}

/**
 * @summary Update the rows of `notification_recipients` matching the given filters.
 */
export const patchNotificationRecipients = async (notificationRecipientsUpdate: NotificationRecipientsUpdate,
    params?: PatchNotificationRecipientsParams, options?: RequestInit): Promise<patchNotificationRecipientsResponse> => {

  const res = await fetch(getPatchNotificationRecipientsUrl(params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(notificationRecipientsUpdate)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: patchNotificationRecipientsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as patchNotificationRecipientsResponse
}


export type deleteNotificationRecipientsResponse200 = {
  data: NotificationRecipients[]
  status: 200
}

export type deleteNotificationRecipientsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type deleteNotificationRecipientsResponseSuccess = (deleteNotificationRecipientsResponse200) & {
  headers: Headers;
};
export type deleteNotificationRecipientsResponseError = (deleteNotificationRecipientsResponseDefault) & {
  headers: Headers;
};

export type deleteNotificationRecipientsResponse = (deleteNotificationRecipientsResponseSuccess | deleteNotificationRecipientsResponseError)

export const getDeleteNotificationRecipientsUrl = (params?: DeleteNotificationRecipientsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/notification_recipients?${stringifiedParams}` : `${backendBaseUrl}/notification_recipients`
}

/**
 * @summary Delete the rows of `notification_recipients` matching the given filters.
 */
export const deleteNotificationRecipients = async (params?: DeleteNotificationRecipientsParams, options?: RequestInit): Promise<deleteNotificationRecipientsResponse> => {

  const res = await fetch(getDeleteNotificationRecipientsUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteNotificationRecipientsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteNotificationRecipientsResponse
}


